/** „X tippt …“ – aus `typing[channelId]` (Ablaufzeitpunkte, Reducer), sekündlich aktualisiert. */
import { useEffect } from 'react';
import { pruneTyping } from '../../realtime/reducer';
import { useAppStore } from '../../store/app';
import { displayName } from '../../store/selectors';
import { useNow } from './hooks';

export function typingText(names: string[]): string {
  if (names.length === 0) return '';
  if (names.length === 1) return `${names[0]} tippt …`;
  if (names.length === 2) return `${names[0]} und ${names[1]} tippen …`;
  if (names.length === 3) return `${names[0]}, ${names[1]} und ${names[2]} tippen …`;
  return 'Mehrere Personen tippen …';
}

export function TypingIndicator({ channelId, serverId }: { channelId: string; serverId: string | null }) {
  const typing = useAppStore((s) => s.typing[channelId]);
  const users = useAppStore((s) => s.users);
  const members = useAppStore((s) => (serverId ? s.members[serverId] : undefined));
  const meId = useAppStore((s) => s.me?.id);
  // Timer läuft nur, solange Einträge vorhanden sind; abgelaufene werden entfernt (dann stoppt er).
  const anyone = !!typing && Object.keys(typing).length > 0;
  const now = useNow(1000, anyone);
  const ids = Object.entries(typing ?? {})
    .filter(([id, until]) => until > now && id !== meId)
    .map(([id]) => id);
  const expired = anyone && Object.values(typing).some((until) => until <= now);
  useEffect(() => {
    if (expired) useAppStore.getState().update((d) => pruneTyping(d, channelId));
  }, [expired, channelId]);
  const names = ids.map((id) => displayName(members?.[id]?.user ?? users[id], members?.[id]));
  return (
    <div className="typing" aria-live="polite" data-testid="typing-indicator" data-count={names.length}>
      {names.length > 0 && (
        <>
          <span className="typing-dots" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
          <span className="truncate">{typingText(names)}</span>
        </>
      )}
    </div>
  );
}
